
import TalentImg1 from "../../images/Rectangle_1325.png"
import Location from "../../images/Icon-material-location-on.png"
import TalentImg2 from "../../images/Rectangle_1326.png"
import TalentImg3 from "../../images/Rectangle_1327.png"
import TalentImg4 from "../../images/Rectangle_1328.png"
import ProfilePic from "../../images/profile-1.png"
import Profile from "../../images/talent/profile-pic.png";
import Price from "../../images/talent/price.png";
import TalentLocation from "../../images/talent/location.png";
import Duration from "../../images/talent/duration.png";
import Language from "../../images/talent/language.png";
import Portfolio from "../../images/talent/portfolio.png";
import FeatureImage from "../../images/talent/feature-image.png";
import option from '../../images/option.png';
import pt1 from '../../images/post-talent/Group 709.png';
import pt2 from '../../images/post-talent/Group 1102.png';
import pt4 from '../../images/post-talent/Group 1103.png';
import pt5 from '../../images/post-talent/Group 729.png';
import pt6 from '../../images/post-talent/Group 727.png';
import pt7 from '../../images/post-talent/Group 711.png';
import pt8 from '../../images/post-talent/Group 719.png';
import pt9 from '../../images/post-talent/Group 707.png';
import pt10 from '../../images/post-talent/Group 717.png';
import pt11 from '../../images/post-talent/Group 1425.png';
import pt12 from '../../images/post-talent/Group 1385.png';


class TalentsAPI {
  static talents = [{
    image: TalentImg1,
    desc: 'I Can Do 50 Data Entry Projects On Various',
    allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
    profilePic: ProfilePic,
    profileName: 'Kaira',
    locationPic: Location,
    location: 'Chennai',
    pay: '500',
    payUnit: 'Day'
  },
  {
    image: TalentImg2,
    desc: 'I Can Do 50 Data Entry Projects On Various',
    allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
    profilePic: ProfilePic,
    profileName: 'Kaira',
    locationPic: Location,
    location: 'Chennai',
    pay: '500',
    payUnit: 'Day'
  },
  {
    image: TalentImg3,
    desc: 'I Can Do 50 Data Entry Projects On Various',
    allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
    profilePic: ProfilePic,
    profileName: 'Kaira',
    locationPic: Location,
    location: 'Chennai',
    pay: '500',
    payUnit: 'Day'
  },
  {
    image: TalentImg4,
    desc: 'I Can Do 50 Data Entry Projects On Various',
    allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
    profilePic: ProfilePic,
    profileName: 'Kaira',
    locationPic: Location,
    location: 'Chennai',
    pay: '500',
    payUnit: 'Day'
  }
  ];

  static talentDesc = {
    name: 'Do You Want High-Quality Graphic Design Work? I Will Help You Out',
    category: 'Graphics & Design',
    subCategory: 'Graphics Design',
    user: {
      name: 'Kaira',
      img: Profile,
      location: 'Chennai'
    },
    featuredImages: [
      FeatureImage, FeatureImage, FeatureImage
    ],
    postedDate: '01 June 2022',
    salientFeatures: [
      {
        name: 'Job Price',
        img: Price,
        content: 'Rs.400/- for basic Graphic design work'
      },
      {
        name: 'Location',
        img: TalentLocation,
        content: 'Rs.Ludhiana, India'
      },
      {
        name: 'Duration',
        img: Duration,
        content: '2 Weeks'
      },
      {
        name: 'Languages Known',
        img: Language,
        content: 'English, Hindi, Tamil'
      },
      {
        name: 'Portfolio/Social',
        img: Portfolio,
        contents: [
          {
            name: 'Linkedin',
            link: 'https://www.linkedin/kaira'
          },
          {
            name: 'Git Hub',
            link: 'https://www.github/kaira'
          }
        ]
      }
    ],
    processIntro: 'Every client has different requirements and wants quality work. So, I have accumulated a series of steps to follow for delivering the work to my clients. Here is the step-by-step process of my graphic design work.',
    processSteps: [
      'Here clients send me all the requirements and instructions, and I go through them to understand them better.',
      'I will then create a design according to the requirements for examination to the client.',
      'The client examines the design and will let me know if it requires any changes or not. If it requires revisions, I will do the same as per his instructions.',
      'After completing all the changes and ensuring the work is done properly, I will submit the final copy in the format requested by the client.'
    ],
    advantages: 'Do you have a bulk order or a small order? Don\'t worry; I will be your ideal choice in that case as I have enough experience to deliver quality work efficiently. Also, my experience allows me to deliver all the work in just 24 hours of ordering. Speed is my first quality, so you can be free from worries about any work delay. <br/><br/>Also, I will create designs that will enhance the look of your website or social media posts and attract new engagements. You can hire me for poster designing, website design, brochure design or simple graphic design work; I am open to all the possible working opportunities with my clients. <br/><br/><strong>Note:</strong> Please drop me a message if you have any concerns about my services or work method. I will be happy to schedule a meeting with you for discussing all the concerns and queries.',
    faqs: [
      {
        question: 'Are You Able To Deliver Graphics Faster than 24 Hours?',
        answer: 'All of my work is delivered within 24 hours of placing the order. If you need your work to be done on an urgent basis, then you can opt for a 12-hour plan as well. However, the charges might be slightly higher than the normal gig.'
      },
      {
        question: 'Do You Also Create Flyers And Social Media Graphic?',
        answer: 'Yes, I can help you in creating all types of graphics to fulfil your purposes. You can purchase different packages and get your work done in a minimum of 24 hours. I will provide you with a JPEG format of the graphic, but if you want, I can send you a print-ready PDF format without any additional charges.'
      },
      {
        question: 'Do You Also Create Flyers And Social Media Graphic?',
        answer: 'Yes, I can help you in creating all types of graphics to fulfil your purposes. You can purchase different packages and get your work done in a minimum of 24 hours. I will provide you with a JPEG format of the graphic, but if you want, I can send you a print-ready PDF format without any additional charges.'
      }
    ]
  }

  static talentTypes = [
    {
      name: "Proof Reading Jobs",
      subject: "Editing, Proofreading, Book Editing, Article Editing, Rewriting etc...",
      to: '/post-talent/proof-reading',
      img: pt1
    }, {
      name: "Content Writing Jobs",
      subject: "Articles & Blog, Web Content, Copy Writing Jobs, Research writing, etc.",
      to: '/post-talent/content-writing',
      img: pt9
    },
    {
      name: "Data Entry Jobs",
      subject: "Classified posting , Form Filling",
      to: '/post-talent/data-entry',
      img: option
    }, {
      name: "Typing Jobs",
      subject: "Data entry, Data Processing",
      to: '/post-talent/typing',
      img: pt7
    },
    {
      name: "Business & Support",
      subject: "Virtual Assistant, Data Entry Jobs, Business Consulting, Customer care",
      to: '/post-talent/business-support',
      img: pt5
    }, {
      name: "Online Survey Jobs",
      subject: "Survey creation, Survey Analysis",
      to: '/post-talent/online-survey',
      img: pt8
    }, {
      name: "Online Tutoring jobs",
      subject: "Tutoring",
      to: '/post-talent/online-tutorial',
      img: pt4
    }, {
      name: "Music & Audio",
      subject: "Voice over, Audio Mixing, Podcast Editing",
      to: '/post-talent/music-audio',
      img: pt10
    },
    {
      name: "Programming & Tech",
      subject: "Website Builder & CMS, Wordpress, Web Programming, Mobile Apps,etc",
      to: '/post-talent/programming-tech',
      img: pt6
    }, {
      name: "Video & Animation",
      subject: "Video Editing, Video Production, Explainer Video, Short Video Ads, etc..",
      to: '/post-talent/video-animation',
      img: pt2
    }, {
      name: "Graphics Design",
      subject: "Banner design, Graphics design",
      to: '/post-talent/graphics-design',
      img: pt11
    }, {
      name: "Translation",
      subject: "Translate books and add subtitle",
      to: '/post-talent/translation',
      img: pt12
    }
  ];


  static getTalents = () => {
    //change this api calling logic with actual API
    return this.talents;
  }

  static getTalentsByType = (type) => {
    //change this api calling logic with actual API
    return this.talents;
  }

  static getTalentDetails = (id) => {
    return {
      talentDetails: this.talentDesc,
      similarTalents: this.getTalents()
    }

  }


}
export default TalentsAPI;